import { render, staticRenderFns } from "./AddSalesData.vue?vue&type=template&id=c80476c2&scoped=true"
import script from "./AddSalesData.vue?vue&type=script&lang=js"
export * from "./AddSalesData.vue?vue&type=script&lang=js"
import style0 from "./AddSalesData.vue?vue&type=style&index=0&id=c80476c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80476c2",
  null
  
)

export default component.exports